<app-page-title [title]="'Create a new account'"></app-page-title>
<app-create-account-form></app-create-account-form>
